"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const MetadataManager_1 = __importDefault(require("../utilities/MetadataManager"));
const TEAM = 'ipexinsights';
/**
 * Class for using Google Analytics and sending events.
 */
class GoogleAnalyticsTarget {
    /**
     * Set up the Google Analytics integration based on given properties.
     * Will initialize and send the first required event.
     * Requires the Google Analytics script to be loaded in advance.
     *
     * @param props Parameters needed to initiate Google Analytics.
     * @returns A Promise from window.sendEvent.
     */
    setupGoogleAnalytics(props) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.checkGaEnabled()) {
                try {
                    return yield window
                        .analyticsInit({
                        countryCode: props.countryCode,
                        languageCode: props.language,
                        platform: props.platform,
                        plannerName: props.plannerName,
                        dev: props.dev
                    })
                        .then(() => {
                        return this.sendPageViewEvent();
                    });
                }
                catch (e) {
                    // eslint-disable-next-line
                    console.error(e);
                }
            }
        });
    }
    /**
     * Send a given set of data to Google Analytics.
     *
     * @param category The category the event belongs to.
     * @param action The action being performed in the event.
     * @param label Event label, optional.
     * @param custom Parameters to include in the custom dimension.
     */
    sendGoogleAnalyticsEvent(category, action, label, custom) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.checkGaEnabled()) {
                try {
                    return yield window.sendEvent({
                        ['event_category']: category,
                        ['event_action']: action,
                        ['event_label']: label,
                        custom: Object.assign({ team: TEAM }, custom)
                    });
                }
                catch (e) {
                    // eslint-disable-next-line
                    console.error(e);
                }
            }
        });
    }
    /**
     * Send an event to Google Analytics with a name and a set of parameters.
     *
     * @param name Name of the event to be sent.
     * @param params Parameters to include in the event.
     * @param custom Parameters to include in the custom dimension.
     */
    sendGoogleAnalyticsEventWithParams(name, params, custom) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.checkGaEnabled()) {
                try {
                    return yield window.sendEvent({
                        name: name,
                        params: params,
                        custom: Object.assign({ team: TEAM }, custom)
                    });
                }
                catch (e) {
                    // eslint-disable-next-line
                    console.error(e);
                }
            }
        });
    }
    /**
     * Check app metadata to see if GA is enabled.
     *
     * @returns True if GA is enabled, false if it's not, or if it's not defined.
     */
    checkGaEnabled() {
        const appMeta = MetadataManager_1.default.getApplicationMetadata();
        if (!('enableGa' in appMeta)) {
            return false;
        }
        if (appMeta.enableGa == null || appMeta.enableGa === false) {
            return false;
        }
        return true;
    }
    /**
     * Send the initial page view event required for Google Analytics to work.
     *
     * @returns A Promise from window.sendEvent.
     */
    sendPageViewEvent() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.checkGaEnabled()) {
                try {
                    return yield window.sendEvent({
                        ['event_category']: 'pageview',
                        ['page_path']: window.location.pathname,
                        ['page_location']: window.location.href,
                        custom: {
                            team: TEAM
                        }
                    });
                }
                catch (e) {
                    // eslint-disable-next-line
                    console.error(e);
                }
            }
        });
    }
}
exports.default = GoogleAnalyticsTarget;
//# sourceMappingURL=GoogleAnalyticsTarget.js.map